import { useContext } from "react";
import { generalButtonStyle } from "../../utils/styles/mainStyles";
import { ThemeContext, VisitorContext } from "../../App";
import { updateVisitor } from "../../utils/visitor/apiCalls";

export const VisitorBodyPopup = (props) => {
    const [visitor,setVisitor] = useContext(VisitorContext);
    const [theme,setTheme] = useContext(ThemeContext);

    return (
        <>
        <div style = {{textAlign: 'center'}}>
        <h2 style = {{textAlign: 'center'}}>Seems like this is your first time visiting</h2>
        <form style = {{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10}}>
            <input 
            value = {visitor.name}
            placeholder= {'Name'}
            id="name"
            onChange = {(e)=> {setVisitor({...visitor,name:e.target.value})}}
            />
            <input 
            value = {visitor.email}
            placeholder= {'Email'}
            id="email"
            onChange = {(e)=> {setVisitor({...visitor,email:e.target.value})}}/>
            <div style = {{width: '100%', justifyItems: 'center', textAlign: 'initial'}}>
                <div>Are you a recruiter?</div>
                <div style = {{}}>
                    <input type="radio" id="yes" value="yes" name = "recruiter" style = {{marginTop: '-1px', verticalAlign: 'baseline'}} onChange = {() => {setVisitor({...visitor,isRecruiter: true})}}/>
                    <label htmlFor="yes">Yes</label><br/>
                    <input type="radio" id="no" name="recruiter" value="no" style = {{marginTop: '-1px', verticalAlign: 'baseline'}}  onChange = {() => {setVisitor({...visitor,isRecruiter: false})}}/>
                    <label htmlFor="no">No</label>
                </div>
            </div>
            <textarea value= {visitor.message} placeholder={"Enter a message you'd like to leave behind"} style = {{width: '90%', height: '100px'}} onChange = {(e) => {setVisitor({...visitor,message:e.target.value})}}></textarea>       
        </form>
        <button style = {generalButtonStyle(theme)} onClick={() => {
            updateVisitor(visitor)
            props.setOpen(false)
            }}>
                Submit
            </button>     
        </div>

        </>
    )
}